'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    teachingPopoverCarouselCardClassNames: function() {
        return teachingPopoverCarouselCardClassNames;
    },
    useTeachingPopoverCarouselCardStyles_unstable: function() {
        return useTeachingPopoverCarouselCardStyles_unstable;
    }
});
const _react = require("@griffel/react");
const teachingPopoverCarouselCardClassNames = {
    root: 'fui-TeachingPopoverCarouselCard'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {}
}, {});
const useTeachingPopoverCarouselCardStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(teachingPopoverCarouselCardClassNames.root, styles.root, state.root.className);
    return state;
};
